import { render, staticRenderFns } from "./TiHome.vue?vue&type=template&id=74c91d70"
import script from "./TiHome.vue?vue&type=script&lang=js"
export * from "./TiHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports